export type StatusKind = "connected" | "waiting" | "error";

export interface StatusProps {
  kind: StatusKind;
  children: React.ReactNode;
  /**
   * Meldet Aenderungen ueber eine Live-Region. Sinnvoll fuer den
   * Verbindungsstatus, der sich ohne Zutun des Nutzers aendert.
   */
  live?: boolean;
}

/**
 * Statuspille.
 *
 * Der farbige Punkt allein traegt keine Bedeutung -- daneben steht immer Text.
 * Damit bleibt der Status auch ohne Farbwahrnehmung erkennbar.
 */
export function Status({ kind, children, live = false }: StatusProps): React.ReactElement {
  return (
    <span
      className={`status status--${kind}`}
      {...(live ? { role: "status", "aria-live": "polite" as const } : {})}
    >
      <span className="status__dot" aria-hidden="true" />
      {children}
    </span>
  );
}
